<template>
  <b-modal v-model="visible" centered hide-header hide-footer size="sm"
           content-class="apt-confirm-content" @hidden="onHidden">
    <div class="apt-confirm">
      <div class="apt-confirm__icon">
        <feather-icon :icon="icon" size="26"/>
      </div>
      <h5 class="apt-confirm__title">{{ title }}</h5>
      <p class="apt-confirm__msg" v-if="message">{{ message }}</p>
      <div class="apt-confirm__actions">
        <b-button variant="outline-secondary" @click="answer(false)">
          {{ $t('operations.cancel') }}
        </b-button>
        <b-button variant="danger" @click="answer(true)">
          <feather-icon icon="TrashIcon" size="14" class="mr-25"/>{{ okText || $t('operations.confirm') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
/**
 * Promise-based destructive confirmation:
 *   const ok = await this.$refs.confirm.open({ title, message, okText })
 * Resolves false when dismissed any other way (ESC, programmatic hide).
 */
export default {
  name: 'AptConfirmModal',
  data: () => ({
    visible: false,
    title: '',
    message: '',
    okText: '',
    icon: 'AlertTriangleIcon',
    resolver: null,
  }),
  methods: {
    open(opts) {
      opts = opts || {}
      this.title = opts.title || ''
      this.message = opts.message || ''
      this.okText = opts.okText || ''
      this.icon = opts.icon || 'AlertTriangleIcon'
      this.visible = true
      return new Promise(resolve => {
        this.resolver = resolve
      })
    },
    answer(value) {
      const resolve = this.resolver
      this.resolver = null
      this.visible = false
      if (resolve) resolve(value)
    },
    onHidden() {
      if (this.resolver) {
        const resolve = this.resolver
        this.resolver = null
        resolve(false)
      }
    },
  },
}
</script>

<style lang="scss">
.apt-confirm-content {
  border: none;
  border-radius: .8rem;
  overflow: hidden;
}
.apt-confirm {
  text-align: center;
  padding: .75rem .5rem .25rem;

  &__icon {
    width: 62px;
    height: 62px;
    margin: 0 auto .75rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ea5455;
    background: rgba(234, 84, 85, .12);
    box-shadow: 0 0 0 8px rgba(234, 84, 85, .05);
  }
  &__title {
    font-weight: 700;
    color: #5e5873;
  }
  &__msg {
    font-size: .85rem;
    color: #6e6b7b;
    margin-bottom: 1rem;
    word-break: break-word;
  }
  &__actions {
    display: flex;
    gap: .5rem;
    justify-content: center;
    padding-bottom: .5rem;

    .btn { min-width: 110px; }
  }
}
.dark-layout {
  .apt-confirm-content { background: #283046; }
  .apt-confirm__title { color: #d0d2d6; }
  .apt-confirm__msg { color: #b4b7bd; }
}
</style>
